import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Components/Sidebar';

function ProtectedRoute({ children }) {
    const location = useLocation();
    const isAuthenticated = localStorage.getItem('token');

    if (!isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were trying to go to
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Wrap children in the Sidebar component
    return (
        <Sidebar>
            {children}
        </Sidebar>
    );
}

export default ProtectedRoute;
